import React, {Component} from 'react';
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Paper from "@material-ui/core/Paper";
import Badge from "@material-ui/core/Badge";

class FeedbackTabs extends Component {
    constructor(props) {
        super(props);
        this.getAllTabsStyle = this.getAllTabsStyle.bind(this);
        this.getTabStyle = this.getTabStyle.bind(this);
    }

    getAllTabsStyle() {
        return {
            elevation: 0,
            shadowOpacity: 0,
            borderBottomWidth: 0,
            boxShadow: "0 0 0 0",
            width: "100%",
            position: "relative"
        };
    }

    getTabStyle() {
        if (this.props.mobile) {
            return {
                width: "50%",
                fontSize: 14,
                fontWeight: 'bold'
            };
        }
        return {
            fontWeight: 'bold'
        };
    }

    render() {
        return (
            <Paper
                square
                style={this.getAllTabsStyle()}>
                <Tabs
                    value={this.props.tab}
                    indicatorColor="primary"
                    textColor="primary"
                    onChange={this.props.handleChangeTab}>
                    <Tab
                        style={this.getTabStyle()}
                        value="positions"
                        label="Positions"
                        disabled={this.props.rank_submitted}
                    />
                    <Tab
                        style={this.getTabStyle()}
                        value="personalFeedbacks"
                        label="Personal Feedbacks"/>
                </Tabs>
            </Paper>

        );
    }
}

export default FeedbackTabs;
